/*
 * Copyright (c) 2026 Aymane Elamrani Chefchaouen & NAJA AI. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of Aymane Elamrani.
 * ("Confidential Information"). You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms of the
 * license agreement you entered into with Aymane Elamrani.
 */

import React from 'react';
import { Shield, Lock, AlertTriangle } from 'lucide-react';

const DisclaimerPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#0A1628] text-white font-sans flex flex-col items-center justify-center p-8">
            <div className="max-w-3xl w-full bg-[#0F1F3A] border border-white/10 rounded-2xl p-12 shadow-2xl relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#06B6D4] via-[#3B82F6] to-[#06B6D4]" />

                <div className="flex justify-center mb-8">
                    <Shield className="w-16 h-16 text-[#06B6D4]" />
                </div>

                <h1 className="text-3xl md:text-4xl font-bold text-center mb-2">LEGAL DISCLAIMER</h1>
                <h2 className="text-xl text-[#06B6D4] text-center mb-8 tracking-widest uppercase">Proprietary Software</h2>

                <div className="space-y-6 text-slate-300 leading-relaxed text-justify">
                    <p>
                        <strong className="text-white">COPYRIGHT NOTICE:</strong> This software, including all source code,
                        algorithms, design elements, and technical implementations ("Techniques"), is the sole
                        property of <strong className="text-white">Aymane Elamrani Chefchaouen</strong> and <strong className="text-white">Naja AI</strong>.
                    </p>

                    <p>
                        Unauthorized access, reproduction, reverse engineering, decompilation, or distribution of this
                        software or any portion thereof is strictly prohibited by international copyright laws and treaties.
                    </p>

                    <div className="bg-red-500/10 border border-red-500/30 p-4 rounded-lg flex gap-4 items-start">
                        <AlertTriangle className="w-6 h-6 text-red-500 shrink-0 mt-1" />
                        <div>
                            <h4 className="text-red-500 font-bold mb-1">STRICTLY CONFIDENTIAL</h4>
                            <p className="text-sm">
                                The techniques used in "Protectly" to ensure public safety are trade secrets.
                                Any attempt to clone, copy, or steal this intellectual property will be met with
                                immediate legal action.
                            </p>
                        </div>
                    </div>

                    <p className="text-sm text-center pt-8 border-t border-white/10 mt-8">
                        © 2026 Aymane Elamrani Chefchaouen. All Rights Reserved. <br />
                        Developed in Chefchaouen, Morocco.
                    </p>
                </div>

                <div className="mt-8 flex justify-center">
                    <button
                        onClick={() => window.history.back()}
                        className="flex items-center gap-2 px-6 py-3 bg-[#06B6D4]/10 hover:bg-[#06B6D4]/20 text-[#06B6D4] rounded-lg transition-colors"
                    >
                        <Lock className="w-4 h-4" />
                        Acknowledge & Return
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerPage;
